import { render } from "./2021-07-03-Blog1.md?vue&type=template&id=2bb0333d"
const script = {}
script.render = render

export default script